export const LABELS = {
    wellInflowCals: "Well inflow calculations",
    tooltipText: "Formulas",
    wellIPRCals: "Well IPR calculations (expand to see IPR curves)",
    wellInflowPerformance: "Well inflow performance",
    includeInMainReport: "Include in main report",
    exportIPRPlot: "Export IPR-Plot",
    futureShutInPressure: "Future shutIn pressure",
    psiUnit: "psi",
    futureProdRate: "Future production rate",
    bpdUnit: "bpd",
    depletionPercentage: "Depletion %:",
    depletionCUrve: 'Depletion curve',
    exportDepletionPlot: 'Export depletion-Plot',
    tdhCals: "TDH calculations",
    tubingHead: "Tubing head",
    frictionLoss: "Friction loss",
    headAtPumpIntake: "Head at pump intake",
    mainPumpNVL: "Main pump net vertical lift",
    requiredMainPumpTDH: "Required main pump TDH",
    requiredSystemTDH: "Required system TDH",
    mainPumpIntakePressure: "Main pump intake pressure",
    newTDH: "New TDH",
    maxFLowRateBpd: "Max. flow rate (bpd)",
    additionalBpd: "Additional BPD (bpd)",
    PI: "PI (bpd/psi)",
    flowingBottomHolePressure: "Flowing bottom hole pressure @ desired production rate (psi)",
    iprSelected: "IPR selected :",
    wiggins: "Wiggins",
    vogel: "Vogel",
    composite: "Composite",
    gilbert: "Gilbert (Cont. PI)",
    note: "Note: If net vertical lift is negative, the well is free flowing.",
};

